import type {
  productDetailResource,
  productResource,
} from '@porotutu/api/features/crm/products/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { PRODUCTS } from '@/api/keys'
import type { CrmProductSort } from '../vocabulary'

export type Product = ReturnType<typeof productResource>

export type ProductDetail = ReturnType<typeof productDetailResource>

export type ProductPage = { data: Product[]; meta: ListMeta }

export type ProductListQuery = ListQuery<CrmProductSort, never>

export const productsQuery = (query: ProductListQuery) =>
  queryOptions({
    queryKey: [...PRODUCTS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.products.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const productQuery = (id: string) =>
  queryOptions({
    queryKey: [...PRODUCTS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.products({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<ProductListQuery>('/api/v1/crm/products/export', {
  always: [],
  viewed: ['search'],
})
